import { isAdminRoute } from '~/lib/admin-route';

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server || !isAdminRoute(to.path)) return;
  try {
    await $fetch('/api/admin/access',{query:{catalog:/^\/admin\/catalog\/seeds(?:\/\d+)?\/?$/.test(to.path)?'true':undefined}});
  } catch (error: any) {
    return abortNavigation(createError({
      statusCode: error?.statusCode || 403,
      message: 'Административный раздел доступен только администраторам.',
    }));
  }
});
